import React from 'react';

// Original, code-native decorative objects. One source shared by the list and QA.
// All objects use the same viewBox, round outline, front view and ground shadow.
const drawings = {
  math: <>
    <path d="M22 23v51M74 23v51M20 75h56" stroke="#7b89ba" strokeWidth="6" />
    <path d="M24 34h48M24 49h48M24 64h48" />
    <rect x="29" y="27" width="10" height="14" rx="4" fill="#89cef4" />
    <rect x="43" y="27" width="10" height="14" rx="4" fill="#89cef4" />
    <rect x="51" y="42" width="10" height="14" rx="4" fill="#f4b8d1" />
    <rect x="37" y="42" width="10" height="14" rx="4" fill="#f4b8d1" />
    <rect x="29" y="57" width="10" height="14" rx="4" fill="#ffda8b" />
    <rect x="43" y="57" width="10" height="14" rx="4" fill="#ffda8b" />
    <rect x="57" y="57" width="10" height="14" rx="4" fill="#ffda8b" />
  </>,
  turkish: <>
    <path d="M16 29q17-7 32 1 15-8 32-1v44q-17-7-32 0-15-7-32 0Z" fill="#f6b8d0" />
    <path d="M20 24q15-6 28 2 13-8 28-2v43q-15-6-28 2-13-8-28-2Z" fill="#fffaf0" />
    <path d="M48 27v42M27 48h13M27 55h11M56 48h13M56 55h10" />
    <path d="m28 40 5-10 5 10m-8-3h6" stroke="#ba5486" />
    <path d="M58 30v10h5q6 0 3-5 3-5-3-5Zm0 5h6" stroke="#7b89ba" />
  </>,
  science: <>
    <path d="M37 29q29-5 29 23 0 17-18 17H32" stroke="#7bb9c6" strokeWidth="9" />
    <path d="m32 20 12-4 12 27-12 5Z" fill="#a5dce4" />
    <path d="m30 20 16-6M43 49l15-6" strokeWidth="5" />
    <path d="M25 58h29M41 59v14" strokeWidth="5" />
    <circle cx="64" cy="51" r="6" fill="#ffda8b" />
    <path d="M27 73h43l5 7H22Z" fill="#a5dce4" />
    <path d="m28 38-3 5m-3-8-4 1" stroke="#e7bc63" />
  </>,
  english: <>
    <path d="M30 40h43q8 0 8 8v18q0 8-8 8h-4l-9 8v-8H38q-8 0-8-8Z" fill="#f7d797" />
    <path d="M15 24q0-8 8-8h41q8 0 8 8v25q0 8-8 8H37L25 68V57h-2q-8 0-8-8Z" fill="#fffaf0" />
    <path d="m23 43 5-15 5 15m-8-5h6M39 28v15h5q8 0 3-8 4-7-3-7Zm0 7h5M63 29q-10-5-10 6 0 11 10 6" stroke="#ac741e" />
  </>,
  life: <>
    <path d="M34 51h28l-4 27H38Z" fill="#f7cd9d" />
    <rect x="30" y="48" width="36" height="9" rx="4" fill="#f9dfba" />
    <path d="M48 48V26" stroke="#3a946d" />
    <path d="M48 38Q24 41 24 20q23-1 24 18Z" fill="#a4dcae" />
    <path d="M48 31q1-20 25-17-2 21-25 17Z" fill="#c5e9ac" />
    <path d="m31 27 17 11m0-7 17-10" stroke="#3a946d" strokeWidth="2" />
  </>,
  social: <>
    <circle cx="45" cy="41" r="25" fill="#b8ddf4" />
    <path d="m27 26 11-5 7 8-6 8-9-1-5 10-4-6m44-10-12 1-2 10 11 4 4 8m-26-9 12 4-2 13-8 5-5-11Z" fill="#b6d9ac" strokeWidth="2" />
    <path d="M61 13q29 20 7 48-9 11-25 10M43 71v9M31 81h30" stroke="#8c7ebc" strokeWidth="5" />
  </>,
  mixed: <>
    <path d="M36 28v-8q12-10 24 0v8" stroke="#8e73ba" strokeWidth="5" />
    <path d="M27 40h-6v29h8m40-29h6v29h-8" fill="#c7b6e7" />
    <rect x="27" y="25" width="42" height="55" rx="12" fill="#c7b6e7" />
    <path d="M28 40q20 13 40 0V36q0-11-12-11H40q-12 0-12 11Z" fill="#e2d5f4" />
    <rect x="34" y="54" width="28" height="18" rx="6" fill="#ffda8b" />
    <path d="M35 60h26" stroke="#b58a48" strokeWidth="2" />
    <rect x="43" y="39" width="10" height="10" rx="3" fill="#fffaf0" />
  </>,
  homework: <>
    <rect x="25" y="17" width="45" height="62" rx="6" fill="#d5dfed" />
    <path d="M34 18v60" stroke="#8b9db7" />
    <path d="M20 29h10M20 42h10M20 55h10M20 68h10" strokeWidth="4" />
    <rect x="41" y="29" width="22" height="16" rx="4" fill="#fffaf0" />
    <path d="M43 55h17M43 63h13" stroke="#8b9db7" />
    <path d="m65 68 9-19 5 3-9 19-6 4Z" fill="#ffda8b" />
  </>,
};

export default function SubjectIllustration({ kind }) {
  return <svg className="teacher-homework-art" data-illustration={kind} viewBox="0 0 96 96" aria-hidden="true" focusable="false">
    <ellipse cx="48" cy="83" rx="32" ry="4" fill="#415279" opacity=".1" />
    <g fill="none" stroke="#526384" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      {drawings[kind] || drawings.homework}
    </g>
  </svg>;
}
